import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    preserveWhitespaces: false,
    standalone: false
})
export class PaginationComponent implements OnChanges {
  @Input() page: number = 1;
  @Input() totalPages: number = 0;
  @Input() totalItems: number = 0;
  @Input() pageSize: number = 20;
  @Input() pageSizes: number[] = [20, 25, 50, 100];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  pages: number[] = [];

  ngOnChanges() {
    this.buildPageList();
  }

  private buildPageList() {
    if (this.totalPages <= 0) {
      this.pages = [];
      return;
    }
    const delta = 2;
    const start = Math.max(1, this.page - delta);
    const end = Math.min(this.totalPages, this.page + delta);
    this.pages = [];
    for (let i = start; i <= end; i++) {
      this.pages.push(i);
    }
  }

  goTo(p: number) {
    if (p < 1 || p > this.totalPages || p === this.page) return;
    this.pageChange.emit(p);
  }

  prev() { this.goTo(this.page - 1); }
  next() { this.goTo(this.page + 1); }
  first() { this.goTo(1); }
  last() { this.goTo(this.totalPages); }

  onPageSizeChange(value: string) {
    const n = Number(value);
    if (n > 0) {
      this.pageSizeChange.emit(n);
    }
  }
}
